import { useState } from 'react';
import { useAppSettings } from '../hooks/useAppSettings';
import { useAuthHeaders } from './useAuthHeaders';

export const useDeleteCategoryDocument = () => {
    const { settings: appSettings } = useAppSettings();
    const { getAuthHeaders } = useAuthHeaders();
    const [isDeleting, setIsDeleting] = useState(false);
    const [deleteError, setDeleteError] = useState<string | null>(null);
    const [deleteSuccess, setDeleteSuccess] = useState(false);

    const deleteCategoryDocument = async (id: number): Promise<void> => {
        if (!appSettings?.api) {
            throw new Error('API settings not available');
        }

        setIsDeleting(true);
        setDeleteError(null);
        setDeleteSuccess(false);

        try {
            const response = await fetch(`${appSettings.api}/DeleteCategoryDocument?id=${id}`, {
                method: 'DELETE',
                headers: getAuthHeaders(),
            });

            if (!response.ok) {
                const errorText = await response.text();
                throw new Error(`Delete failed (${response.status}): ${errorText}`);
            }

            setDeleteSuccess(true);
        } catch (error: any) {
            setDeleteError(error.message || 'Failed to delete category document');
            throw error;
        } finally {
            setIsDeleting(false);
        }
    };

    const clearMessages = () => {
        setDeleteError(null);
        setDeleteSuccess(false);
    };

    return {
        deleteCategoryDocument,
        isDeleting,
        deleteError,
        deleteSuccess,
        clearMessages,
    };
};
